import { CURVA_FILE_EXTENSION } from "@/io/fileTypes";

export function isCurvaFilePath(path: string): boolean {
  return path.toLowerCase().endsWith(CURVA_FILE_EXTENSION);
}

export function isCurvaFileDrag(dataTransfer: DataTransfer): boolean {
  if (Array.from(dataTransfer.files).some(file => isCurvaFilePath(file.name))) {
    return true;
  }
  return Array.from(dataTransfer.items).some(item => {
    if (item.kind !== "file") {
      return false;
    }
    // Some browsers expose the name only after getAsFile().
    const file = item.getAsFile();
    return file ? isCurvaFilePath(file.name) : false;
  });
}

export async function readCurvaFilesFromDataTransfer(dataTransfer: DataTransfer): Promise<Array<{ name: string; bytes: Uint8Array }>> {
  const files = Array.from(dataTransfer.files).filter(file => isCurvaFilePath(file.name));
  const opened: Array<{ name: string; bytes: Uint8Array }> = [];
  for (const file of files) {
    opened.push({
      name: file.name,
      bytes: new Uint8Array(await file.arrayBuffer()),
    });
  }
  return opened;
}
